export const reassignAndTerminateSearchApprover_actionType = {
    REASSIGN_AND_TERMINATE_SEARCH_APPROVER: "REASSIGN_AND_TERMINATE_SEARCH_APPROVER",
    REASSIGN_AND_TERMINATE_SEARCH_APPROVER_SUCCESS: "REASSIGN_AND_TERMINATE_SEARCH_APPROVER_SUCCESS",
    REASSIGN_AND_TERMINATE_SEARCH_APPROVER_ERROR: "REASSIGN_AND_TERMINATE_SEARCH_APPROVER_ERROR",
    REASSIGN_AND_TERMINATE_SEARCH_APPROVER_RESET: "REASSIGN_AND_TERMINATE_SEARCH_APPROVER_RESET"
};